import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {MaterialNotesPage} from "./-page/material-notes.page";
import {MaterialNotesPending} from "./-page/material-notes.pending";
import {materialNotesSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/engineering/materials/$materialId/notes/")({
  component: RouteComponent,
  pendingComponent: MaterialNotesPending,
  staticData: {meta: {labelDescriptor: routeMessages.notes}},
  validateSearch: (search) => materialNotesSearchSchema.parse(search),
});

function RouteComponent() {
  const {materialId} = useParams({strict: false}) as {materialId: string};
  const {includeDeleted} = Route.useSearch();

  return <MaterialNotesPage materialId={materialId} includeDeleted={includeDeleted} />;
}
